import dayjs from 'dayjs'
import localeData from 'dayjs/plugin/localeData'
import isBetween from 'dayjs/plugin/isBetween'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import 'dayjs/locale/th'

export default defineNuxtPlugin(() => {
  dayjs.extend(localeData)
  dayjs.extend(isBetween)
  dayjs.extend(customParseFormat)
  dayjs.locale('th') // หรือจะให้เปลี่ยนตาม locale ก็ได้

  return {
    provide: {
      dayjs
    }
  }
})